import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import MainList from './main';
import { RoleType } from './types';
import { XTabNav } from '@/components/xqxc_ui';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const tabList = [
    { id: RoleType.USER_APP, label: '客户端' },
    { id: RoleType.RIDER_APP, label: '骑手端' },
    { id: RoleType.OPERATION_COMPANY, label: '运营公司' }
];

const Slide = (props) => {

    const [curTabID, setCurTabID] = useState(RoleType.USER_APP);

    useEffect(() => {
        props.setBreadcrumbPaths(props.match);
    }, []);

    return (
        <div className={styles.flexBoxContainer}>
            <XTabNav renderData={tabList} onChange={setCurTabID} activedID={curTabID} />
            <MainList key={curTabID} curTabID={curTabID} {...props} />
        </div>
    );
};

Slide.propTypes = {
    history: PropTypes.object,//路由对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func
};

export default connect(null, { setBreadcrumbPaths })(Slide);